import { useTranslations } from 'next-intl';
import { showShortsDateRange } from '@/utils/common';
import { getCardPriceData } from './price_utils';

export const CardPrice = ({ daysAmount, price, date }) => {
  const t = useTranslations();

  const { hasPrice, hasDiscount, totalMoneyValue, discountedMoneyValue } =
    getCardPriceData({ daysAmount, price, t });

  return (
    <div className="ml-auto flex flex-col text-right max-w-full items-end">
      <div className="text-slate-700 text-sm font-normal leading-tight lg:mb-1.5">
        {showShortsDateRange(
          price?.startDate
            ? { startDate: price?.startDate, endDate: price?.endDate }
            : date
        )}
      </div>
      {hasDiscount && (
        <div
          className="text-slate-500 text-sm font-semibold line-through leading-tight"
          data-testid="card-price-total"
        >
          {totalMoneyValue} {t(price?.unit || 'total')}
        </div>
      )}
      {hasPrice && (
        <div className="flex flex-wrap gap-y-0.5 max-list-2xl:gap-x-1.5 list-2xl:gap-x-3 items-center max-lg:order-2 justify-end">
          <span
            className="text-slate-500 text-base font-normal underline truncate"
            data-testid="card-price-total-2"
          >
            {discountedMoneyValue} {t(price?.unit || 'total')}
          </span>
        </div>
      )}
    </div>
  );
};
